import { Box } from '@trmediaab/zebra';
import PropTypes from 'prop-types';

import Article from '~/components/Article';
import LatestArticles from '~/components/LatestArticles';
import PageMeta from '~/components/PageMeta';
import Paywall from '~/containers/Auth/Paywall';
import Content from '~/containers/Content';

const ArticlePage = ({
  location: {
    type,
    payload: { slug },
    routesMap,
  },
}) => (
  <Content
    slug={slug}
    render={(content, hasPremium) => {
      const { access, meta } = content;
      const hasAccess = hasPremium || access !== 1;

      // TODO space below promo

      return (
        <Box bg="white" px={{ _: 3, md: '3,5' }} py={{ _: 3, md: '3,5' }}>
          <PageMeta meta={meta} />
          <Article
            type={type}
            premiumLocked={!hasAccess}
            hasPremium={hasPremium}
            article={content}
          />
          {!hasAccess && <Paywall fade isArticle />}
          {!['PAGE', 'BET_TYPE', 'ABOUT_PAGE'].includes(type) && (
            <LatestArticles
              slug={slug}
              type={type}
              model={routesMap[type].meta.listModel}
              limit={routesMap[type].meta.listLimit}
            />
          )}
        </Box>
      );
    }}
  />
);

ArticlePage.propTypes = {
  location: PropTypes.shape({
    payload: PropTypes.shape({
      slug: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

export default ArticlePage;
